import { ReactNode } from "react";
import { getDisplayInfo } from "utils/formatting";
import { percentageDifference } from "utils/mathFormulas/mathFormulas.helper";

export const prepareEnergyOutcomesChart = (
    referencePlan: CarbonReductionPlan,
    comparedPlan: CarbonReductionPlan,
    referencePlanName: string,
    comparedPlanName: string
) => {
    // Lifetime Energy
    const referencePlanLifetimeEnergy = referencePlan.planLifetimeEnergyConsumptionTotal;
    const comparedPlanLifetimeEnergy = comparedPlan.planLifetimeEnergyConsumptionTotal;
    const energyDifference = percentageDifference(comparedPlanLifetimeEnergy, referencePlanLifetimeEnergy);

    // Chart Data
    const chartEnergyData = transformToEnergyChartData(referencePlan.annualSummaries, comparedPlan.annualSummaries);

    // Tooltip
    const { unit: refEnergyUnit, formatFunction: energyFormatFunction } = getDisplayInfo(
        "totalEnergyConsumption",
        referencePlanLifetimeEnergy
    );
    const { unit: compEnergyUnit } = getDisplayInfo("totalEnergyConsumption", comparedPlanLifetimeEnergy);
    const formatedEnergyRef = energyFormatFunction(referencePlanLifetimeEnergy);
    const formatedEnergyComp = energyFormatFunction(comparedPlanLifetimeEnergy);

    const tooltipElement: ReactNode = (
        <>
            {comparedPlanName} emissions are {formatedEnergyComp} {compEnergyUnit}
            <br />
            <br />
            {referencePlanName} emissions are {formatedEnergyRef} {refEnergyUnit}
            <br />
            <br />
            There is a {energyDifference.toFixed(0)}% difference between the two plans
        </>
    );

    return {
        chartEnergyData,
        referencePlanLifetimeEnergy,
        comparedPlanLifetimeEnergy,
        energyDifference,
        tooltipElement,
        formatedEnergyRef,
        refEnergyUnit,
        energyFormatFunction,
    };
};

const transformToEnergyChartData = (referenceAnnualSummary: AnnualSummary[], comparedAnnualSummary: AnnualSummary[]) =>
    referenceAnnualSummary
        .map((referenceYear) => {
            const matchingComparedYear = comparedAnnualSummary.find(
                (comparedYear) => comparedYear.year === referenceYear.year
            );

            return {
                totalEnergyReference: referenceYear.annualEnergyConsumptionTotal,
                totalEnergyCompared: matchingComparedYear?.annualEnergyConsumptionTotal,
                year: referenceYear.year,
            };
        })
        .sort((a, b) => a.year - b.year);
